import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import { HttpMethods, CORE_SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { CLIENT, ENV } from '../../config';
import { ThunkAPI } from '../rootReducer';
import { isIncrowdClient } from '../../utils/clients';

export enum EventLabels {
  ExportAccounts = 'non-core:export-accounts',
  ExportUsers = 'non-core:export-users',
  ExportInvoice = 'non-core:export-invoice',
  UsersList = 'non-core:users',
  AccountsList = 'non-core:accounts',
  InvoiceList = 'non-core:invoice',
  AccountSettings = 'non-core:settings',
  AccountBilling = 'non-core:billing',
  AccountApiKey = 'non-core:apiKey',
  AccountSSO = 'non-core:sso',
}
interface IEventParams {
  label: string;
  extraFields?: { [key: string]: string };
}

interface IEventBaseFields {
  type: EventTypes;
  hostName: string;
  env: string;
  screenWidth: number;
  screenHeight: number;
}

interface IEventExtraFields {
  projectId?: string;
  projectStatus?: string;
  invoiceNumber?: string;
}

type IEvent = IEventBaseFields & IEventExtraFields;

export enum EventTypes {
  EVENT = 'event',
}

const getEventCommonFields = () => {
  const screenWidth = Math.trunc((window.screen.width * window.devicePixelRatio) || 0);
  const screenHeight = Math.trunc((window.screen.height * window.devicePixelRatio) || 0);

  return {
    type: EventTypes.EVENT,
    hostName: window.location.hostname,
    env: ENV,
    client: CLIENT,
    screenWidth,
    screenHeight
  };
};

export const logEvent:AsyncThunk<void, IEventParams, ThunkAPI> = createAsyncThunk(
  'eventCollector',
  (data: IEventParams, thunk) => {
    if (isIncrowdClient()) {
      return;
    }

    const event = {
      label: data.label,
      ...getEventCommonFields(),
      ...data.extraFields
    };
    return apiAsyncThunkCreator<void, { events: IEvent[] }>({
      endpoint: '/capture',
      microservice: CORE_SERVICES.EVENTS_COLLECTOR_SERVICE,
      authenticated: true,
      method: HttpMethods.Post
    })({ events: [event] }, thunk);
  }
);
